'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.validation.error.directive', [])
  .directive('validationError', function () {
    return {
      restrict: 'E',
      templateUrl: require('./validationError.html'),
      scope: {
        message: '@'
      }
    };
  }
);



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/validation/validationError.directive.js